import { render, staticRenderFns } from "./history.component.vue?vue&type=template&id=2103567f&scoped=true"
import script from "./history.component.ts?vue&type=script&lang=ts&external"
export * from "./history.component.ts?vue&type=script&lang=ts&external"
import style0 from "./history.style.scss?vue&type=style&index=0&id=2103567f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103567f",
  null
  
)

export default component.exports